module.exports = __webpack_public_path__ + "static/img/news-20220915.1ec1411.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20220915.png
// module id = cFzJ
// module chunks = 0